<template>
  <van-popup v-model:show="show" :class="{ hasSearch: allDatas && allDatas.length }" round position="bottom" safe-area-inset-bottom>
    <van-search v-if="allDatas && allDatas.length" class="search" v-model="value" @update:model-value="change" placeholder="请输入轮胎规格" />
    <van-picker :title="title" :visible-item-count="7" :columns="columns" @confirm="confirmFn" @cancel="show = false" />
  </van-popup>
</template>

<script>
import { reactive, toRefs, watch } from 'vue'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  props: ['showPopUp', 'datas', 'allDatas', 'title'],
  emit: ['emitClick'],
  setup(props, { emit }) {
    let { showPopUp, datas, allDatas, title } = toRefs(props)
    const state = reactive({
      showPopUp,
      datas,
      allDatas,
      columns: [],
      show: false,
      title,
      value: ''
    })
    watch(
      () => state.showPopUp,
      () => {
        state.columns = state.datas.length ? state.datas : state.allDatas
        state.value = ''
        state.show = true
      }
    )
    const confirmFn = val => {
      if (val.disabled) {
        Toast({
          message: `请选择有效数据`,
          position: 'bottom'
        })
        return
      }
      emit('emitClick', val)
      state.show = false
    }
    const change = _.debounce(async val => {
      let resutl = ''
      if (val) {
        val = val.toUpperCase()
        resutl = state.allDatas.filter(item => item.includes(val))
        if (!resutl.length) {
          resutl = [
            {
              text: '没有找到匹配数据',
              disabled: true
            }
          ]
        }
      } else {
        if (!state.datas || !state.datas.length) {
          resutl = state.allDatas
        } else {
          resutl = state.datas
        }
      }
      state.columns = resutl
    }, 200)
    return {
      ...toRefs(state),
      confirmFn,
      change
    }
  }
}
</script>

<style lang="scss" scoped>
.hasSearch {
  :deep(.van-picker__toolbar) {
    padding-bottom: 60px;
  }
}

.search {
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  width: 90%;
  :deep(.van-search__content) {
    border-radius: 1.05333rem;
    background-color: #f0f0f0 !important;
  }
}
</style>
